<template>
	<NuxtLayout>
		<NuxtLoadingIndicator color="var(--header-color)" />
		<NuxtPage />
	</NuxtLayout>
</template>
